// Compact row inside MarketplaceSidebar's RecentList — one per id
// in `host.recentIds`. Resolves the id to a catalog item inside the
// parent's `children` fn + spreads the item props, so this component
// receives `name`, `logo`, `kind`, etc. directly as el.* keys (same
// pattern as similar-item rows).
//
// Click opens detail via selectItemFresh (clears history — the
// recent list isn't a journey-entry, it's a leap back).

export const MarketplaceRecentItem = {
  flow: 'x',
  align: 'center',
  gap: 'Y',
  padding: 'X Y',
  borderRadius: 'Y',
  cursor: 'pointer',
  background: 'transparent',
  ':hover': { background: 'line' },
  // Native browser tooltip — shows the full description on hover
  // since the compact row only has space for the name.
  title: (el) => el.description || el.name || '',

  onClick: (e, el) => el.call('openDetailFromEl', el),

  RecentLogo: {
    align: 'center center',
    width: 'Y2',
    height: 'Y2',
    minWidth: 'Y2',
    borderRadius: 'X',
    overflow: 'hidden',
    fontWeight: '700',
    fontSize: 'X',
    background: (el) => el.parent.logo
      ? 'white'
      : el.call('getKindAccent', el.parent.kind, 'bg'),
    color: (el) => el.call('getKindAccent', el.parent.kind, 'fg'),

    RecentLogoImg: {
      hide: (el) => !el.parent.parent.logo || el.parent._imgFailed,
      tag: 'img',
      src: (el) => {
        const slug = el.parent.parent.logo
        return slug ? `https://cdn.simpleicons.org/${slug}` : ''
      },
      alt: (el) => el.parent.parent.name,
      width: '60%',
      height: '60%',
      objectFit: 'contain',
      onRender: (el) => {
        if (!el.node) return
        el.node.onerror = () => {
          el.parent._imgFailed = true
          el.node.style.display = 'none'
          const letter = el.parent.RecentLogoLetter
          if (letter?.node) letter.node.style.display = ''
        }
      }
    },
    RecentLogoLetter: {
      hide: (el) => !!el.parent.parent.logo && !el.parent._imgFailed,
      tag: 'span',
      text: (el) => (el.parent.parent.name || '')[0]?.toUpperCase() || '?'
    }
  },

  RecentName: {
    tag: 'span',
    text: (el) => el.parent.name,
    fontSize: 'Y',
    color: 'paragraph',
    flex: '1',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}
